<template>
  <div>
    <StaffContents
    :profileImg="require('../../assets/img/gen/staff/01/profile.jpg')"
    :profileImgSp="require('../../assets/img/gen/staff/01/profile_sp.jpg')"
    profileAlt="01 飯野真"
    answer01="英会話、留学、サークル、旅行……など、興味のあることになんでも挑戦していました。中でも印象に残っているのは、所属していたフットサルチームでオーストラリア遠征にいったこと。メンバーのほとんどが英語を話せなかったので、私が現地の大会運営者の方とやりとりをして、大会の参加申請や宿舎・航空券の手配などを行いました。と言っても、当時決して高い英語力があったわけではないので、今思えばすごい度胸だなぁと我ながら思います（笑）。"
    answer02="就職活動中に様々な企業の方とお会いする中で、クレハ社員の方のお話にもっとも心を動かされました。一人ひとりが信念を持って仕事に取り組んでいることや、生活を支える「素材」を自分たちの手で開発し世界中に広げていることに、とてもワクワクしたのを覚えています。また、もともと興味があった炭素繊維を扱っている点や、グローバルにビジネスを展開しているところも魅力的に感じ、クレハへの入社を決めました。"
    answer03="クロルベンゼンという有機製品の営業を担当。顧客や市場の情報収集から、販売・生産・在庫計画の立案、物流の効率化等を行なっています。担当している顧客は数十社にわたり、国内はもちろんインドへの輸出も担当しております。その中で意識しているのは、常に「どうしたら相手に動いてもらえるか」を意識しながらコミュニケーションをとること。お客様にとってメリットをきちんと伝えた上で、長期的に良い関係が築けるような提案を心がけています。"
    answer04="インドに何度も足を運んで商談を重ねることで、現地でお世話になっているインド人のトレーダーの方との親交を深められたことです。休日に現地の遺跡を案内していただいたり、ストリートフードを一緒に楽しませていただいたことは良い思い出です。インドでは他人を自宅に招くことがあまり一般的ではないようなのですが、「次は自宅に招待するよ」と言われた際には嬉しかったですね。彼らが日本に来る際には、四季を感じられる風景や美味しい食事などで「おもてなし」をしてあげたいと思っています。"
    answer05="私の担当製品であるクロルベンゼンは、大きな事業環境の変革期を迎えています。クレハの未来を担うような製品事業へと持続させるための、とても大切な時期なんです。私のミッションは、新規市場開拓のひとつとしてインドとより良い関係性を築いていくこと。そのための個人スキルとして英語力を鍛えています。会社の英会話教育プログラムを利用しているのですが、会社の補助でレッスンを受けられるので、非常にありがたいですね。"
    answer06="若手でも熱意さえあれば「自分で考えてやってみろ」と仕事を任せてもらえるところ。もちろん困難にぶつかることもありますが、その度に上司や先輩が成功する方法を一緒に考えてくれます。また、ワークライフバランスが非常に充実していることも魅力的。有給休暇を取得しやすい雰囲気もありますし、プライベートの時間も大切にしている社員が多いです。私は最近同僚に登山に誘われたのをきっかけに、山の素晴らしさに気づきました（笑）。次は長期休暇を利用して海外の山にも挑戦したいです。"
    :imageCut01="require('../../assets/img/gen/staff/01/image01.jpg')"
    :imageCut02="require('../../assets/img/gen/staff/01/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/gen/staff/01/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/gen/staff/01/image02_sp.jpg')"
    :schedule="require('../../assets/img/gen/staff/01/schedule.svg')"
    :scheduleSp="require('../../assets/img/gen/staff/01/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/gen/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
